import template from "./navbar.html";
import {NavbarController} from "./navbar.controller";
import "./navbar.scss";

const navbarComponent = {
	template,
	controller: NavbarController,
	controllerAs: "navbar",
	require: {
		app: "^^app"
	}
};

export default navbarComponent;


// WEBPACK FOOTER //
// ./sources/components/layout/navbar/navabar.component.js